module.exports = __webpack_public_path__ + "static/img/twoab.c3a5c0b4.png";